import React, { useState } from 'react';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import HelpOutline from '@material-ui/icons/HelpOutline';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ClearIcon from '@material-ui/icons/Clear';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

const pickerStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        paddingTop: '0px',
        paddingBottom: '0px'
    },
    item: {
        paddingTop: '0',
        paddingBottom: '0'
    },
    check: {
        padding: '4px'
    },
    icon: {
        minWidth: 'auto'
    },
    headerWrap: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    },
    header: {
        fontSize: '1.1em !important',
        marginBottom: '0px !important',
        paddingTop: '1px !important',
    },
    clearButton: {
        fontSize: '0.8em !important',
        padding: '0.1em !important',
        marginTop: '0 !important'
    },
    acc: {
        border: '0px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        marginBottom: '4px',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&.Mui-expanded': {
            margin: '0',
            marginBottom: '4px'
        },
        '& .MuiAccordionSummary-content': {
            margin: '0',
        },
        paddingLeft: '0px',
        marginLeft: '0px'
    },
    accHead: {
        margin: 0,
        flexDirection: "row-reverse",
        minHeight: 'auto !important',
        alignItems: 'flex-start',
        '&.expanded': {
            margin: '0',
            minHeight: 'auto !important'
        },
        '& .MuiIconButton-root': {
            padding: '2px',
            margin: 0
        },
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: 'var(--hoverGrey)'
        },
        '& .MuiAccordionSummary-content': {
            justifyContent: 'space-between'
        },
        paddingLeft: '0px',
        marginLeft: '0px'
    },
    accContent: {
        paddingTop: '0px',
        paddingBottom: '0px',
        paddingLeft: '0px',
        marginLeft: '0px'
    }
}));
const TagPicker = (props) => {
    const classes = pickerStyles();
    const { tag, UpdateTags, open, enabled } = props;
    const [isOpen, setIsOpen] = useState(open ?? false);
    const handleOpen = () => {
        setIsOpen(!isOpen);
    };
    const handleToggle = (optionId) => {
        return function () {
            if (enabled)
                UpdateTags(optionId);
        }
    };

    return (
        <Accordion className={classes.acc} square expanded={isOpen} onChange={handleOpen}>
            <AccordionSummary id={"taglist-subheader-"+ (props?.mobile ? "m" : "") + tag.id} className={classes.accHead} expandIcon={<ExpandMoreIcon />} >
                <Box className={classes.headerWrap}>
                    <Typography component="h3" variant="h3" className={classes.header}>{tag.name}</Typography>
                </Box>
                {tag.description ?
                    <Tooltip title={tag.description}><IconButton aria-label="show description" size="small"><HelpOutline /></IconButton></Tooltip>
                    : ""
                }
            </AccordionSummary>
            <AccordionDetails className={classes.accContent}>
                <List className={classes.root} aria-labelledby={"taglist-subheader-" + (props?.mobile ? "m" : "") + tag.id}>
                    {tag.options.map((option) => {
                        const labelId = `checkbox-list-label-${option.id}`;
                        return (
                            <ListItem className={classes.item} key={'option' + option.id} button onClick={handleToggle(option.id)}>
                                <ListItemIcon className={classes.icon}>
                                    {tag.type === "multiple" ? (<Checkbox className={classes.check}
                                        edge="start"
                                        checked={'enabled' in option ? option.enabled : false}
                                        tabIndex={-1}
                                        disableRipple
                                        color="primary"
                                        disabled={!enabled}
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />) : (<Radio edge="start" className={classes.check}
                                        checked={'enabled' in option ? option.enabled : false}
                                        tabIndex={-1}
                                        disableRipple
                                        color="primary"
                                        disabled={!enabled}
                                        inputProps={{ 'aria-labelledby': labelId }} />)
                                    }
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={option.name} />
                            </ListItem>
                        );
                    })}
                </List>
            </AccordionDetails>
        </Accordion>
    );
};

export default TagPicker;
